angular.module('wbControllers').controller(
  'ProfileController',
  ['$scope', '$rootScope', '$location', '$routeParams', '$sce', 'Subscriptions', 'Profile', 'users', 'User', 'wbConfig', '$timeout', 'locale', 'Client', '$window',
    ($scope, $rootScope, $location, $routeParams, $sce, Subscriptions, Profile, users, User, wbConfig, $timeout, locale, Client, $window) => {
      $scope.config = wbConfig;

      let clientProfileBackup = {};
      const user = users.getCurrentUser();

      $scope.passwordInput = { password: '' };

      $scope.userIsStaff = users.hasRole('staff');

      // hack to allow dev to properly access the form and it's values in the ctrl
      // instantiates the wrapper and adds the form to the wrapper object in the index.html file
      $scope.wrapper = {};

      let hasExternalAdvisor = false;

      if ($routeParams.step === 'subscriptions') {
        Subscriptions.query({ userId: $routeParams.userId && $scope.userIsStaff ? $routeParams.userId : undefined }, (subscriptions) => {
          $scope.subscriptions = subscriptions;
        });
        hasExternalAdvisor = $window.currentUser.hasExternalAdvisor;
      } else if ($routeParams.userId && $scope.userIsStaff) {
        // Admin: Load profile (of any given user)
        $scope.myName = `${$routeParams.userId}'s`;
        Client.get({ id: $routeParams.userId }, (clientProfile) => {
          $scope.clientProfile = clientProfile;
          $scope.clientProfile.language = $scope.clientProfile.language
            || locale.getCurrentLanguage();
          clientProfileBackup = _.cloneDeep(clientProfile);
        });
      } else {
        // Client: Load profile (own profile)
        Profile.get((clientProfile) => {
          $scope.clientProfile = clientProfile;
          $scope.clientProfile.language = $scope.clientProfile.language
            || locale.getCurrentLanguage();
          return (clientProfileBackup = _.cloneDeep(clientProfile));
        });
        hasExternalAdvisor = $window.currentUser.hasExternalAdvisor;
      }

      $scope.steps = [{
        name: 'basics',
        view: 'profile/basics',
        show: true,
        title: 'Account Basics',
      },
      {
        name: 'email',
        template: $sce.trustAsHtml('<profile-email client-profile="clientProfile">'),
        show: true,
        title: 'E-mail Address',
        noForm: true,
      },
      {
        name: 'personal',
        template: $sce.trustAsHtml('<profile-personal client-profile="clientProfile" disable-two-factor="disableTwoFactor()">'),
        show: true,
        title: 'Personal Details',
      },
      // tax Residency is inserted here conditionally
      {
        name: 'marital-status',
        view: 'profile/marital-status',
        show: true,
        title: 'Marital Status',
      },
      {
        name: 'dependents',
        view: 'profile/dependents',
        show: true,
        title: 'Dependents',
      },
      {
        name: 'financial',
        template: $sce.trustAsHtml('<profile-financial set-dirty="setDirty()" client-profile="clientProfile">'),
        show: true,
        title: 'Household Finances',
      },
      {
        name: 'subscriptions',
        view: 'profile/subscriptions',
        show: true,
        title: 'Email Notifications',
      },
      {
        name: 'link-with-partner',
        template: $sce.trustAsHtml('<profile-link-partner client-profile="clientProfile">'),
        show: !users.hasRole('staff'),
        title: 'Link Accounts',
        noForm: true,
      },
      {
        name: 'security',
        template: $sce.trustAsHtml('<two-factor-auth-dashboard client-profile="clientProfile">'),
        show: !users.hasRole('staff'),
        title: 'Security',
        noForm: true,
      },
      // My Advisor is inserted here only if the client has an advisor
      ];

      if (!user.hideBeneficiaryDesignation) {
        $scope.steps.splice(7, 0, {
          name: 'beneficiaries',
          template: $sce.trustAsHtml('<profile-beneficiaries client-profile="clientProfile">'),
          show: true,
          title: 'Beneficiaries',
          noForm: true,
        })
      }

      if (user.hasAccounts) {
        $scope.steps.splice(3, 0, {
          name: 'tax-residency',
          template: $sce.trustAsHtml('<profile-tax-info client-profile="clientProfile">'),
          show: true,
          title: 'Tax Residency',
          noForm: true,
        });
      }

      if (user.hasAccounts) {
        $scope.steps.splice(7, 0, {
          name: 'bankinfo',
          template: $sce.trustAsHtml('<profile-banking-info-v2 client-profile="clientProfile">'),
          show: true,
          title: 'Bank Accounts',
          noForm: true,
        });
      }

      if (hasExternalAdvisor) {
        $scope.steps.splice($scope.steps.length, 0, {
          name: 'representative-info',
          template: $sce.trustAsHtml('<profile-advisor-info client-profile="clientProfile">'),
          show: true,
          title: 'My Representative',
          noForm: true,
        });
      };

      $scope.currentStep = $routeParams.step || 'basics';

      $scope.step = _.find($scope.steps, step => (step.name === $scope.currentStep) && step.show);
      $scope.step = $scope.step || { notFound: true };

      let waiting = null;

      Object.assign($scope, {
        save(form) {
          if (!form.$pristine && !waiting) {
            $scope.wrapper.profileForm = form;
            if ($scope.currentStep === 'email') {
              $scope.updateEmailAddress();
            } else if ($scope.currentStep === 'subscriptions') {
              $scope.updateSubscriptions();
            } else {
              $scope.updateProfile();
            }
          }
        },
        ownerOfProfileIsSelf() {
          return !$routeParams.userId || Number($routeParams.userId) === users.getCurrentUser().id;
        },
        updateProfile() {
          $scope.error = null;
          $scope.success = null;
          waiting = true;

          if ($scope.ownerOfProfileIsSelf() &&
            $scope.clientProfile.language !== locale.getCurrentLanguage()) {
            locale.setLanguage($scope.clientProfile.language, true);
          }

          return $scope.clientProfile.$update(
            () => {
              $scope.wrapper.profileForm.$setPristine();
              waiting = false;
              $scope.success = true;
              Profile.get((clientProfile) => {
                $scope.clientProfile = clientProfile;
                $scope.clientProfile.language = $scope.clientProfile.language || locale.getCurrentLanguage();
                $window.currentUser.firstName = $scope.clientProfile.firstName;
                $window.currentUser.lastName = $scope.clientProfile.lastName;
                $window.currentUser.name = $scope.clientProfile.name;
              });
            },
            (response) => {
              waiting = false;
              if (response.data && response.data.message) {
                $scope.error = response.data.message;
              } else {
                $scope.error = response.data;
              }
            },
          );
        },
        updatePassword() {
          if (user.twoFactorEnabled) {
            $rootScope.$broadcast('confirmTwoFactor');
            $scope.$on('confirmTwoFactorSuccess', $scope.passwordDialog.show);
          } else {
            $scope.passwordDialog.show();
          }
        },
        updateEmailAddress() {
          $scope.error = null;
          $scope.success = null;
          waiting = true;
          if (users.hasRole('staff')) {
            $scope.updatedClientProfile = new Profile({
              email: $scope.clientProfile.email,
              id: $scope.clientProfile.id,
            });
          } else {
            $scope.updatedClientProfile = new Profile({
              email: $scope.clientProfile.email,
              password: $scope.passwordInput.password,
            });
          }

          $scope.updatedClientProfile.$updateEmail(
            () => {
              $scope.wrapper.profileForm.$setPristine();
              waiting = false;
              if ($scope.success) {
                $scope.clientProfile = $scope.updatedClientProfile;
                $scope.passwordInput.password = undefined;
                $scope.passwordConfirmDialog.hide();
              }
            },
            (response) => {
              waiting = false;

              // TODO As we move away from ActiveRecord, we should replace this with hand-rolled,
              // probably server-side validation that doesn't need to be post-processed like this.
              if (response.status === 403) {
                $scope.error = 'Invalid password';
              } else if (response.data.message === 'Email has already been taken') {
                $scope.error = 'That e-mail address is already associated with a CI Direct Investing account, please contact your advisor if you need help.';
              } else {
                $scope.error = response.data.message;
              }
            },
          );
        },
        updateSubscriptions() {
          $scope.error = null;
          $scope.success = null;

          const subscriptionData = $scope.subscriptions.map(subscription =>
            ({ id: subscription.id, isSubscribed: subscription.isSubscribed }));
          Subscriptions.updateSubscriptions({ subscriptions: subscriptionData }, () => {
            $scope.success = true;
            $scope.wrapper.profileForm.$setPristine();
          });
        },
        disableTwoFactor() {
          User.disableTwoFactorAuth({ id: $routeParams.userId });
          $scope.clientProfile.twoFactorEnabled = false;
          $scope.clientProfile.twoFactorPhone = '';
        },
        addDependent() {
          $scope.clientProfile.dependents.push({ name: '', dateOfBirth: '' });
          $scope.clientProfile.dependentsCount = $scope.clientProfile.dependents.length;
          $scope.setDirty();
        },
        removeDependent(dependent) {
          _.remove($scope.clientProfile.dependents, dependent);
          $scope.clientProfile.dependentsCount = $scope.clientProfile.dependents.length;
          $scope.setDirty();
        },
        setDirty() {
          $scope.wrapper.profileForm.$setDirty();
        },

        addAsset(type, name) {
          $scope.clientProfile.assets.push({
            type,
            typeName: name,
            name: `My ${name}`,
            balance: 0,
          });
          $scope.setDirty();
        },
        addDebt(type, name) {
          $scope.clientProfile.debts.push({
            type,
            typeName: name,
            name: `My ${name}`,
            balance: 0,
            payment: 0,
            paymentFrequency: 12,
            interestRate: 0.04,
          });
          $scope.setDirty();
        },
        removeAsset(asset) {
          _.remove($scope.clientProfile.assets, asset);
          return $scope.setDirty();
        },
        removeDebt(debt) {
          _.remove($scope.clientProfile.debts, debt);
          $scope.setDirty();
        },
        netWorth() {
          return _.sumBy($scope.clientProfile.assets, 'balance') - _.sumBy($scope.clientProfile.debts, 'balance');
        },

        go(step) {
          const pathSegments = $location.path().split('/');
          pathSegments[pathSegments.length - 1] = step;
          return $location.path(pathSegments.join('/'));
        },
        discardChanges() {
          angular.copy(clientProfileBackup, $scope.clientProfile);
          $scope.wrapper.profileForm.$setPristine();
          $scope.passwordInput.password = '';
        },
      });

      function getDiscardChangesOnRouteChangeFunction(route) {
        return () => {
          angular.copy(clientProfileBackup, $scope.clientProfile);
          $scope.wrapper.profileForm.$setPristine();
          return $scope.go(route);
        };
      }

      function getBackToFormFunction(route) {
        return () => {
          const inputButton = angular.element(document.getElementById(route));
          return $timeout(() => inputButton.trigger('click'));
        };
      }

      $scope.$on('$routeChangeStart', (e, next) => {
        if ($scope.wrapper.profileForm != null ? $scope.wrapper.profileForm.$dirty : undefined) {
          e.preventDefault();
          $scope.cancelChangesRouteChangeDialog.show();
          $scope.discardChangesRoute = getDiscardChangesOnRouteChangeFunction(next.pathParams.step);
          $scope.backToForm = getBackToFormFunction($scope.currentStep);
        }
      });

      return ($scope.optionShow = ($scope.currentStep === 'basics'));
    },
  ],
);
